export const getTakeoffErrorContentFromCode = (errorCode: string) => {
    switch (errorCode) {
        case "1":
            return {
                title: "No Account Found",
            };
        case "2":
            return {
                title: "Email Address Required",
                content: (
                    <>
                        <p>
                            Buildertrend Takeoff cannot create a new account until a valid email
                            address is added to your Buildertrend user preferences.
                        </p>
                        <p>Once updated you can finish connecting to Buildertrend Takeoff.</p>
                    </>
                ),
            };
        case "3":
            return {
                title: "Already Connected to Buildertrend Takeoff",
                content: (
                    <>
                        <p>
                            The account this user belongs to has already been connected to another
                            organization on Buildertrend.
                        </p>
                        <p>
                            Try checking the email address and password you're using to log in or
                            contact our support team for more assistance.
                        </p>
                    </>
                ),
            };
        case "4":
            return {
                title: "Email Address Already in Use",
                content: (
                    <>
                        <p>
                            Buildertrend Takeoff cannot create a new account because your email
                            address is already in use.
                        </p>
                        <p>
                            Update the email address in your Buildertrend user preferences and try
                            connecting again.
                        </p>
                    </>
                ),
            };
        default:
            return {
                title: "Unable to Connect",
                content: (
                    <>
                        Buildertrend was unable to connect with Buildertrend Takeoff. Try again to
                        connect and if this issue continues, please contact our support team for
                        assistance.
                    </>
                ),
            };
    }
};
